import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useFormik } from "formik";
import { Box, Flex, Center, Heading, Text, useToast } from "@chakra-ui/react";
import FormFields from "./Fields";
import { FormValidationSchema } from "./utils";
import FormBody from "./FormBody";

const FormPreview = ({
  title,
  formFields,
  standardFields,
  formSubmissionConfig,
  formConfig,
  previewMode = false,
  formWidth = "531px",
}) => {
  const {
    messageText: confirmationMessage,
    configType: formSubmissionType,
    redirectExternalPage,
    redirectWordpressPage,
  } = formSubmissionConfig;
  const [shouldRedirect, setRedirect] = useState(false);

  const toast = useToast();
  const { formValidationSchema } = new FormValidationSchema(formFields);
  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      address: {
        addressLine1: "",
        addressLine2: "",
        state: "",
        city: "",
        country: "",
        zipCode: "",
      },
      textField: JSON.parse(JSON.stringify(standardFields.textField)),
      url: JSON.parse(JSON.stringify(standardFields.url)),
      paragraph: JSON.parse(JSON.stringify(standardFields.paragraph)),
      number: JSON.parse(JSON.stringify(standardFields.number)),
      dropDown: JSON.parse(JSON.stringify(standardFields.dropDown)),
      checkBox: JSON.parse(JSON.stringify(standardFields.checkBox)),
      rating: JSON.parse(JSON.stringify(standardFields.rating)),
    },
    validationSchema: formValidationSchema,
    onSubmit: (values) => {
      switch (formSubmissionType) {
        case "CONFIRMATION_MESSAGE": {
          toast({
            position: "top-right",
            title: "Form Submitted.",
            description: confirmationMessage,
            status: "success",
            duration: 4000,
            isClosable: true,
          });
          return;
        }
        case "REDIRECT_EXTERNAL_PAGE":
          return setRedirect(true);
        case "REDIRECT_WORDPRESS_PAGE":
          return setRedirect(true);
      }
    },
  });
  useEffect(() => {
    if (shouldRedirect && formSubmissionType == "REDIRECT_EXTERNAL_PAGE") {
      window.open(redirectExternalPage, "_blank");
    }
    if (shouldRedirect && formSubmissionType == "REDIRECT_WORDPRESS_PAGE") {
      console.log("redirectWordpressPage",redirectWordpressPage)
      window.open(redirectWordpressPage, "_blank");
    }
  }, [shouldRedirect]);
  return previewMode ? (
    <FormBody formConfig={formConfig} formik={formik} title={title} />
  ) : (
    <Flex
      bg="#F5F7F9"
      w="531px"      
      m="0 auto 0 auto"
      p="0"
      direction="column"
      justify="flex-start"
    >
      <Center mt="33.8px" mb="24.28px" w="100%" bg="background.primary">
        <Text fontSize="16px" fontWeight="semibold" color="#12344D">Preview</Text>
      </Center>
      <FormBody
        formConfig={formConfig}
        formWidth={formWidth}
        formik={formik}
        title={title}
      />
    </Flex>
  );
};

const mapStateToProps = (state) => {
  return {
    title: state.templates.currentTemplate.title,
    formFields: state.form.dropped,
    standardFields: state.form.standardFields,
    formConfig: state.form,
    formSubmissionConfig: state.formConfig,
  };
};

export default connect(mapStateToProps)(FormPreview);
